import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { keepParams } from '@homamo/meadow-utils';
import Error from '../../common/ErrorMessage';
import AdminNav from '../../admin/AdminNav';

const LenderNotFoundComponent = ({ id, displayError }) => {
  return (
    <>
      <AdminNav />
      <h1>404. Lender not found</h1>
      <p>No lender found with ID: {id}</p>
      <p>
        <Link to={keepParams('/lenders')}>Back to all lenders</Link>
      </p>
      {displayError && displayError.message && (
        <>
          <p>
            <small>
              The following information may be useful for technical support:
            </small>
          </p>
          <Error error={displayError} />
        </>
      )}
    </>
  );
};

LenderNotFoundComponent.propTypes = {
  id: PropTypes.string.isRequired,
  displayError: PropTypes.shape({
    message: PropTypes.string,
  }),
};

LenderNotFoundComponent.defaultProps = {
  displayError: {},
};

export default LenderNotFoundComponent;
